import { useTranslation } from "react-i18next";
import { SearchIcon } from "lucide-react";

interface SearchEmptyStateProps {
  query: string;
}

export const SearchEmptyState = ({ query }: SearchEmptyStateProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="flex flex-col items-center gap-3 pb-2 pt-4 text-center">
      <span className="flex size-11 items-center justify-center rounded-full bg-muted text-muted-foreground">
        <SearchIcon className="size-5" />
      </span>
      <div className="space-y-1">
        <p className="text-sm font-medium text-foreground">
          {query
            ? t("common:chrome.no_results_for_query", { query })
            : t("common:chrome.nothing_found")}
        </p>
        <p className="text-xs text-muted-foreground">
          {query
            ? t("common:chrome.try_different_term_examples")
            : t("common:chrome.start_typing_to_search_pages_and_actions")}
        </p>
      </div>
    </div>
  );
};
